import Image1 from '../../assets/SonTung.jpg'
import Image2 from '../../assets/BaoTram.png'
import Image3 from '../../assets/HaiTu.jpeg'

export const Data = [
    {
        id: 1,
        image: Image1,
        title: "Son Tung",
        description:
            "Nếu tôi thay đổi bản thân vì muốn chiều lòng antifan thì chưa chắc họ yêu mến tôi hơn. Tôi nghĩ người nghệ sĩ nên kiên định và tin vào sự lựa chọn của mình. Hải Tú ngon hơn cô gái khác."
    },
    {
        id: 2,
        image: Image2,
        title: "Bao Tram",
        description:
            "Lòng chung thuỷ của người phụ nữ được thử thách khi người đàn ông của cô ấy không có gì trong tay. Lòng chung thuỷ của người đàn ông được thử thách khi anh ta có trong tay tất cả mọi thứ."
    },
    {
        id: 3,
        image: Image3,
        title: "Hai Tu",
        description:
            "Cô ấy nắn nót, sửa từng lỗi sai của bạn và mong muốn sẽ được đối xử tốt hơn với cô ấy... Và rồi cũng chính cô ấy lặng lẽ ngồi nhìn bạn đối xử với người sau với cái cách mà cô luôn khao khát."
    },
]
